import type { CellContext, ColumnDef } from '@tanstack/react-table';
import type { TFunction } from 'i18next';
import { Observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { EReportFlavorsRaw, Person } from '@feathr/blackbox';
import { DateTimeCell, TanStackHeader } from '@feathr/components';
import { TimeFormat } from '@feathr/hooks';
import {
  createPersonNameColumn,
  getFirstFlavorHit,
} from '@feathr/report_components/utils/engagementPersonColumns';

import { flavorToInteractionMap } from './CampaignEngagementCard';

function campaignEngagementColumns(
  t: TFunction,
  localUrl: ((url: string) => string) | undefined,
  activeFlavor: EReportFlavorsRaw,
): Array<ColumnDef<Person>> {
  const nameColumn = createPersonNameColumn(t, localUrl);

  const interactionColumn: ColumnDef<Person> = {
    id: 'interaction',
    header: () => <TanStackHeader title={t('Interaction')} />,
    enableSorting: false,
    meta: { align: 'center' },
    cell: (): JSX.Element => <>{flavorToInteractionMap(t)[activeFlavor]}</>,
  };

  const interactionDateColumn: ColumnDef<Person> = {
    id: 'first_interacted',
    header: () => <TanStackHeader title={t('First interacted')} />,
    enableSorting: false,
    meta: { align: 'center' },
    cell: ({ row }: CellContext<Person, unknown>): JSX.Element => (
      <Observer>
        {function useAnonymousFunction(): JSX.Element {
          return (
            <DateTimeCell
              emptyText={'—'}
              format={TimeFormat.shortDateTime}
              value={getFirstFlavorHit(row.original)?.d_c}
            />
          );
        }}
      </Observer>
    ),
  };

  return [nameColumn, interactionColumn, interactionDateColumn];
}

export default campaignEngagementColumns;
